module.exports = __webpack_public_path__ + "img/socio12.58d1ae5a.png";